import IcFavoriteTick from './ADSFavoriteTick.svg'
import IcFavoriteUntick from './ADSFavoriteUntick.svg'
import {useState} from "react";
import axiosInstance from "../../../../../../../../../../../../axiosInstance";
import {useADSContext} from "../../../../../../../../context/ADSProvider";

const ADSProductFavorite = ({id, favorite}) => {
  const {projectId} = useADSContext();

  const [isFavorite, setIsFavorite] = useState(favorite);

  const handleFavoriteProduct = (e) => {
    setIsFavorite(!isFavorite);
    e.stopPropagation();

    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = `/services/projectmanagement/api/products/${id}`
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .patch(fullUrl, {
          id,
          projectId,
          favorite: !isFavorite,
        })
        .then((res) => resolve(res.data))
        .catch(reject)
    })
  }

  return (
    <img 
      src={isFavorite ? IcFavoriteTick : IcFavoriteUntick}
      alt='favorite-product'
      onClick={handleFavoriteProduct}
      style={{width: 20, height: 20}}
    />
  );
};

export default ADSProductFavorite;
